/*
 * Copyright (c) 2024. Tooling Team
 */

import { useEffect } from "react";
import Layout from "../components/layout/Layout";
import { Card } from "@uhg-abyss/web/ui/Card";
import { Text } from "@uhg-abyss/web/ui/Text";
import { PATHS } from "../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { PageBodyIntro } from "@uhg-abyss/web/ui/PageBodyIntro";
import { PageBody } from "@uhg-abyss/web/ui/PageBody";
import { Button } from "@uhg-abyss/web/ui/Button";
import { AuthLoading } from "../components/auth/authLoading";
import { useGetUserProfileQuery } from "../app/services/userApi";
import { setAdminUserAccess } from "../utils/authz";

export function HomePage() {
  const {
    data: userProfile,
    isError,
    isFetching,
    isLoading,
  } = useGetUserProfileQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (isError) {
      setAdminUserAccess(false);
      return;
    }

    if (userProfile) {
      setAdminUserAccess(userProfile.isAdmin === true);
    }
  }, [isError, userProfile]);

  if (isLoading || isFetching) {
    return <AuthLoading loadingText="Checking access..." />;
  }

  const isAdmin = userProfile?.isAdmin === true;
  const editMap = () => {
    location.href = PATHS.editMapMapValueDefinition.url;
  };
  const createMap = () => {
    location.href = PATHS.createMap.url;
  };

  const medDomainCDR = () => {
    location.href = PATHS.medDomain.url;
  };
  const medDomainEIS = () => {
    location.href = PATHS.medDomainEIS.url;
  };

  return (
    <Layout>
      <PageBodyIntro
        title="Mapping Intelligence and Normalization Toolkit"
        css={{
          "abyss-page-body-intro-heading": {
            whiteSpace: "nowrap",
          },
        }}
      />
      <PageBody>
        <div className="row mt-4 mb-4">
          <div className="col d-flex">
            <Card className="text-center h-100 w-100 d-flex flex-column justify-content-start">
              <div className="mt-4 mb-4 card-icon">
                <FontAwesomeIcon
                  icon={solid("network-wired")}
                  className="icon-link"
                />
                <Text fontSize="lg" fontWeight="bold" asElement="div">
                  Map Management
                </Text>
              </div>
              <div className="d-flex flex-row justify-content-center gap-2">
                <Button onClick={createMap} variant="outline">
                  Create Map
                </Button>
                <Button onClick={editMap} variant="outline">
                  Edit Map
                </Button>
              </div>
            </Card>
          </div>
          {isAdmin && (
            <div className="col d-flex">
              <a
                href={PATHS.admin.url}
                className="d-flex w-100 text-decoration-none"
              >
                <Card className="text-center h-100 w-100 d-flex flex-column justify-content-start">
                  <div className="mt-4 mb-4 card-icon">
                    <FontAwesomeIcon
                      icon={solid("gears")}
                      className="icon-link"
                    />
                    <Text fontSize="lg" fontWeight="bold" asElement="div">
                      Administration
                    </Text>
                  </div>
                </Card>
              </a>
            </div>
          )}
          <div className="col d-flex">
            <Card className="text-center h-100 w-100 d-flex flex-column justify-content-start">
              <div className="mt-4 mb-4 card-icon">
                <FontAwesomeIcon
                  icon={solid("list-check")}
                  className="icon-link"
                />
                <Text fontSize="lg" fontWeight="bold" asElement="div">
                  Builds
                </Text>
              </div>
              <div className="d-flex flex-row justify-content-center gap-2">
                <Button onClick={medDomainCDR} variant="outline">
                  Legacy
                </Button>
                <Button onClick={medDomainEIS} variant="outline">
                  Modern
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </PageBody>
    </Layout>
  );
}
